import { render, staticRenderFns } from "./partners-add.vue?vue&type=template&id=7b688bd8&scoped=true&"
import script from "./partners-add.ts?vue&type=script&lang=ts&"
export * from "./partners-add.ts?vue&type=script&lang=ts&"
import style0 from "./partners-add.scss?vue&type=style&index=0&id=7b688bd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b688bd8",
  null
  
)

export default component.exports